import { gql } from 'graphql-request'
import { Experiment as ExperimentType } from '../../../types'

interface ExperimentCli {
  assignExperiment(data: {
    flag: string
    personProperties?: Record<string, string | number | boolean>
  }): Promise<ExperimentType>
}

const Experiment = (graphQL: any): ExperimentCli => {
  const assignExperiment: ExperimentCli['assignExperiment'] = async ({
    flag,
    personProperties = {}
  }) => {
    const variables = {
      flag,
      personProperties
    }

    const query = gql`
      mutation AssignExperiment($flag: String!, $personProperties: JSON!) {
        assignExperiment(flag: $flag, personProperties: $personProperties) {
          flag
          value
        }
      }
    `

    const result = await graphQL({ query, variables })

    return result?.assignExperiment
  }

  return {
    assignExperiment
  }
}

export default Experiment
